import AvatarUploader from './AvatarUploader';

export default AvatarUploader;
